if (!customElements.get("variant-picker")) {
	class VariantPicker extends HTMLElement {
		constructor() {
			super()
			this.section = this.closest(".js-product")
			this.productForm = this.section.querySelector(".js-product-form-main")
			this.optionSelectors = this.querySelectorAll(".option-selector")
			this.data = this.getProductData()
			this.variant = this.getSelectedVariant()
			this.discountBanner = document.querySelector('.discount-banner');
			this.labelPreOrder = document.querySelector('.preorder-label');
			this.initial = true;

			this.updateAvailability()
			this.updateAddToCartButton()
			this.addEventListener("change", this.handleVariantChange.bind(this))

			// Actualizar la imagen destacada en la carga inicial
			this.updateFeaturedImage()
		}

		handleVariantChange(evt) {
			this.variant = null
			this.variant = this.getSelectedVariant()

			if (this.variant) {
				this.updateMedia()
				this.updateUrl(evt)
				this.updateVariantInput()
				this.updateBannerDiscount();
			}

			this.updateAddToCartButton(evt)
			this.updateAvailability()
			this.updatePrice()
			this.updateWeight()
			this.updateBarcode()
			this.updateBackorderText()
			this.updatePickupAvailability()
			this.updateSku()
			VariantPicker.updateLabelText(evt)

			// Actualizar la imagen destacada en el cambio de variante
			this.updateFeaturedImage()

			this.dispatchEvent(
				new CustomEvent("on:variant:change", {
					bubbles: true,
					detail: {
						form: this.productForm,
						variant: this.variant,
						product: this.data.product,
					},
				})
			)
			const selectedVariant = this.getSelectedVariant()
			if (selectedVariant) {
				$("#sticky-add-cart-container").load(window.location.href + " #sticky-add-cart-container", function () {
					// Llama a la función para reinicializar los scripts
					initStickyAddCartScripts()
				})
			} else {
				const selector = evt.target.closest(".option-selector")
				const colorText = selector.querySelector(".js-color-text").innerText
				const colorImg = document
					.querySelector("input:checked+.opt-label--swatch, input:checked+.filter__label[data-swatch]:before")
					?.querySelector("img")?.src

				disableAddToCart()
				let nameSelected = document.getElementById("name-selected")
				const stickyImg = document.getElementById("swatch-selected").querySelector("img")
				colorImg ? (stickyImg.src = colorImg) : null
				nameSelected.innerHTML = colorText
			}

			this.updateLabelPreOrder(evt);
		}

		updateFeaturedImage() {
			const featuredImage = this.section.querySelector(".featured-image")
			if (!featuredImage || !this.variant) return

			const firstColorVariant = this.data.product.variants.find((variant) => variant.option1 === this.variant.option1)
			if (firstColorVariant && firstColorVariant.featured_media) {
				featuredImage.src = firstColorVariant.featured_media.src
				featuredImage.alt = firstColorVariant.featured_media.alt
			}
		}

		updateAddToCartButton(evt) {
			this.productForm = this.section.querySelector(".js-product-form-main")
			if (!this.productForm) return

			this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]')
			let variantAvailable = this.variant && this.variant.available
			let unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant

			if(evt || this.initial){
				let target = evt?.target;
				if(this.initial){
					target = this.section.querySelector('input[checked]');
				} 
				if(target.dataset.textOrder){
					unavailableStr = target.dataset.textOrder;
				}
				this.initial = false;
			}

			this.addBtn.disabled = !variantAvailable
			this.addBtn.textContent = variantAvailable ? this.addBtn.dataset.addToCartText : unavailableStr
		}

		updateAvailability() {
			const selectedOptions = this.getSelectedOptions()
			if (this.dataset.showAvailability === "false") return
			let currVariant = this.variant

			if (!this.variant) {
				currVariant = { options: this.getSelectedOptions() }
			}

			const updateOptionAvailability = (optionEl, available, soldout) => {
				const el = optionEl
				let text = '';
				if(el.classList.contains('variant_with-preorder')){
					text = el.dataset.textOrder;
				} else {
					text = soldout ? theme.strings.noStock : theme.strings.noVariant
				}
				el.classList.toggle("is-unavailable", !available)

				if (optionEl.classList.contains("custom-select__option")) {
					const em = el.querySelector("em")

					if (em) {
						em.hidden = available
					}

					if (!available) {
						if (em) {
							em.textContent = text
						} else {
							el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${text}</em>`
						}
					}
				} else if (!available) {
					el.nextElementSibling.title = text
				} else {
					el.nextElementSibling.removeAttribute("title")
				}
			}

			this.querySelectorAll(".js-option").forEach((optionEl) => {
				updateOptionAvailability(optionEl, false, false)
			})

			this.optionSelectors.forEach((selector, selectorIndex) => {
				this.data.product.variants.forEach((variant) => {
					let matchCount = 0

					variant.options.forEach((option, optionIndex) => {
						if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
							matchCount += 1
						}
					})

					if (matchCount === currVariant.options.length - 1) {
						const options = selector.querySelectorAll(".js-option")
						const optionEl = Array.from(options).find((opt) => {
							if (selector.dataset.selectorType === "dropdown") {
								return opt.dataset.value === variant.options[selectorIndex]
							}
							return opt.value === variant.options[selectorIndex]
						})

						if (optionEl) {
							updateOptionAvailability(optionEl, variant.available, !variant.available)
						}
					}
				})
				if (selector.querySelector("legend.label").innerText.includes("Tamaño")) {
					const inputs = selector.querySelectorAll("input")
					const optionsWithAvailability = []

					inputs?.forEach((input) => {
						const label = document.querySelector(`label[for="${input.id}"]`)
						label.style.display = "block"

						if (input.classList.contains("is-unavailable")) {
							label.style.display = "none"
						}else {
							optionsWithAvailability.push(input)
						}
					})

					if (!optionsWithAvailability.length){
						selector.style.display = "none"
					}
				}
				if (selector.querySelector("legend.label").innerText.includes("Color")) {
					const inputs = selector.querySelectorAll("input")
					const optionsWithAvailability = []
					
					inputs?.forEach((input) => {
						const label = document.querySelector(`label[for="${input.id}"]`)
						
						label.style.display = "block"

						const inputValue = input.value

						const variantsOfColor = this.data.product.variants.filter(variant => {
							return variant.option1 == inputValue
						})

						const hasAvailbility = variantsOfColor.some(size => size.available)

						if(!hasAvailbility) {
							label.style.display = "none"
						}else {
							optionsWithAvailability.push(input)
						}
					})
					if (!optionsWithAvailability.length){
						selector.style.display = "none"
					}
				}
			})
			if (this.optionSelectors.length == 1) {
				const selector = this.optionSelectors[0]
				const inputs = selector.querySelectorAll("input")
				inputs?.forEach((input) => {
					const label = document.querySelector(`label[for="${input.id}"]`)
					label.style.display = "block"

					if (input.classList.contains("is-unavailable")) {
						label.style.display = "none"
					}
				})
			}
		}

		updateBackorderText() {
			this.backorder = this.backorder || this.section.querySelector(".backorder")
			if (!this.backorder) return

			let hideBackorder = true

			if (this.variant && this.variant.available) {
				const { inventory } = this.data.formatted[this.variant.id]

				if (this.variant.inventory_management && inventory === "none") {
					const backorderProdEl = this.backorder.querySelector(".backorder__product")
					const prodTitleEl = this.section.querySelector(".product-title")
					const variantTitle = this.variant.title.includes("Default") ? "" : ` - ${this.variant.title}`

					backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`
					hideBackorder = false
				}
			}

			this.backorder.hidden = hideBackorder
		}

		static updateLabelText(evt) {
			const selector = evt.target.closest(".option-selector")
			if (selector.dataset.selectorType === "dropdown") return

			const colorText = selector.querySelector(".js-color-text")
			if (!colorText) return

			colorText.textContent = evt.target.nextElementSibling.querySelector(".js-value").textContent
		}

		updateMedia() {
			if (!this.variant.featured_media) return

			if (this.section.matches("quick-add-drawer")) {
				this.section.updateMedia(this.variant.featured_media.id)
			} else {
				this.mediaGallery = this.mediaGallery || this.section.querySelector("media-gallery")
				if (!this.mediaGallery) return

				const variantMedia = this.mediaGallery.querySelector(`[data-media-id="${this.variant.featured_media.id}"]`)
				this.mediaGallery.setActiveMedia(variantMedia, true, true)
			}
		}

		updatePickupAvailability() {
			this.pickUpAvailability = this.pickUpAvailability || this.section.querySelector("pickup-availability")
			if (!this.pickUpAvailability) return

			if (this.variant && this.variant.available) {
				this.pickUpAvailability.getAvailability(this.variant.id)
			} else {
				this.pickUpAvailability.removeAttribute("available")
				this.pickUpAvailability.innerHTML = ""
			}
		}

		updatePrice() {
			this.priceEl = this.priceEl || this.section.querySelector(".product-info__price > .price")

			if (!this.priceEl) return

			if (this.variant) {
				const priceCurrentEl = this.priceEl.querySelector(".product-price__default")
				const priceWasEl = this.priceEl.querySelector(".product-price__was")
				const unitPriceEl = this.priceEl.querySelector(".unit-price")


				priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price
				if (priceWasEl) priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || ""

				if (this.variant.unit_price_measurement) {
					const valueEl = this.priceEl.querySelector(".unit-price__price")
					const unitEl = this.priceEl.querySelector(".unit-price__unit")
					const value = this.variant.unit_price_measurement.reference_value
					const unit = this.variant.unit_price_measurement.reference_unit

					valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice
					unitEl.textContent = value === 1 ? unit : `${value} ${unit}`
				}

				unitPriceEl.hidden = !this.variant.unit_price_measurement
				this.priceEl.classList.toggle("price--on-sale", this.variant.compare_at_price > this.variant.price)
				this.priceEl.classList.toggle("price--sold-out", !this.variant.available)
			}

			this.priceEl.querySelector(".price__default").hidden = !this.variant
			this.priceEl.querySelector(".price__no-variant").hidden = this.variant
		}

		updateWeight() {
			this.weights = this.weights || this.section.querySelectorAll(".product-info__weight")
			if (this.weights.length === 0) return

			const weightAvailable = this.variant && this.variant.weight > 0
			this.weights.forEach((weight) => {
				weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : ""
				weight.hidden = !weightAvailable
			})
		}

		updateBarcode() {
			this.barcodes = this.barcodes || this.section.querySelectorAll(".product-info__barcode-value")
			if (this.barcodes.length === 0) return

			const barcodeAvailable = this.variant && this.variant.barcode
			this.barcodes.forEach((barcode) => {
				barcode.textContent = barcodeAvailable ? this.variant.barcode : ""
				barcode.parentNode.hidden = !barcodeAvailable
			})
		}

		updateSku() {
			this.sku = this.sku || this.section.querySelector(".product-sku__value")
			if (!this.sku) return

			const skuAvailable = this.variant && this.variant.sku
			this.sku.textContent = skuAvailable ? this.variant.sku : ""
			this.sku.parentNode.hidden = !skuAvailable
		}

		updateUrl(evt) {
			if (!evt || evt.type !== "change" || this.dataset.updateUrl === "false") return
			window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.variant.id}`)
		}

		updateLabelPreOrder(evt) {
			const { target } = evt;
			if(target.dataset.textOrder){
				this.labelPreOrder.textContent = target.dataset.textOrder;
				this.labelPreOrder.classList.remove('hidden');
			} else {
				this.labelPreOrder.classList.add('hidden');
			}
			
		}

		updateVariantInput() {
			this.forms = this.forms || this.section.querySelectorAll(".js-product-form-main, .js-instalments-form")

			this.forms.forEach((form) => {
				const input = form.querySelector('input[name="id"]')
				input.value = this.variant.id
				input.dispatchEvent(new Event("change", { bubbles: true }))
			})
		}

		updateBannerDiscount(evt){
			const { compare_at_price, price } = this.variant;
			if(!compare_at_price || compare_at_price == 0 ){
				if(price >= 10000){
					this.discountBanner.classList.remove('hidden');
				} else {
					this.discountBanner.classList.add('hidden');
				}
			} else {
				this.discountBanner.classList.add('hidden');
			}
		}

		getSelectedOptions() {
			const selectedOptions = []

			this.optionSelectors.forEach((selector) => {
				if (selector.dataset.selectorType === "dropdown") {
					selectedOptions.push(selector.querySelector(".custom-select__btn").textContent.trim())
				} else {
					selectedOptions.push(selector.querySelector("input:checked").value)
				}
			})

			return selectedOptions
		}

		getProductData() {
			const dataEl = this.querySelector('[type="application/json"]')
			return JSON.parse(dataEl.textContent)
		}

		getSelectedVariant() {
			const selectedOptions = this.getSelectedOptions()
			return this.data.product.variants.find((v) => v.options.every((val, index) => val === selectedOptions[index]))
		}
	}

	customElements.define("variant-picker", VariantPicker)
}
